import { RECEIVE_BASE_DATA, UPDATE_LOADING, SHOW_ABOUT } from '../actions';
// import getQueryParameterByName from '../utils/getQueryParameterByName';

// const skipToView = getQueryParameterByName('view');
// const skipToResults = getQueryParameterByName('skipToResults');
// const viewId = skipToResults ? 'results' : skipToView || 'loading';

export const base = (state = { app: { loading: true, about: { visible: false } }, personas: [], archetypes: [] }, action) => {
  switch (action.type) {
    case RECEIVE_BASE_DATA:
      const { app, personas, archetypes } = action;
      return Object.assign({}, {
        ...state,
        app: Object.assign(state.app, {
          ...app
        }),
        personas,
        archetypes
      });
    case UPDATE_LOADING:
        return Object.assign({}, {
          ...state,
          app: Object.assign({}, {
            ...state.app,
            loading: action.loading
          })
        });
    case SHOW_ABOUT:
      return Object.assign({}, {
        ...state,
        app: Object.assign({}, {
          ...state.app,
          about: { visible: action.visible }
        })
      });
    default:
      return state;
  }
}
